import { z } from 'zod';
import { HistorySchema, LinkTypeSchema } from './commons';
import { TeleserviceSchema } from './teleservice';
import { DemandeFinancementEntitySchema } from './demandes-financement';
export var ContributionInformationStatusEnum;
(function (ContributionInformationStatusEnum) {
    ContributionInformationStatusEnum["INPROGRESS"] = "INPROGRESS";
    ContributionInformationStatusEnum["ANSWERED"] = "ANSWERED";
    ContributionInformationStatusEnum["SUPPORTED"] = "SUPPORTED";
    ContributionInformationStatusEnum["CLOTURE"] = "CLOTURE";
})(ContributionInformationStatusEnum || (ContributionInformationStatusEnum = {}));
export const ContributionInformationContentSchema = z.object({
    date: z.string().optional(),
    type: LinkTypeSchema.optional(),
    motif: LinkTypeSchema.optional(),
    commentaire: z.string().optional(),
});
export const ContributionInformationApprobationSchema = z.object({
    decision: z.enum(['accepted', 'refused']).optional(),
    date: z.string(),
    precisions: z.string().optional(),
});
export const RecapitulatifSchema = LinkTypeSchema.extend({
    size: z.number(),
    date: z.string(),
});
export const ContributionInformationSchema = z.object({
    id: z.string(),
    reference: z.string(),
    tenant: z.string(),
    status: z.nativeEnum(ContributionInformationStatusEnum),
    information: ContributionInformationContentSchema,
    teleservice: LinkTypeSchema,
    demande: LinkTypeSchema,
    approbation: ContributionInformationApprobationSchema.optional(),
    history: HistorySchema,
    recapitulatif: RecapitulatifSchema.optional(),
});
export const ContributionInformationDepotContextPiecesSchema = z.object({
    visibles: z.array(z.string()),
    obligatoires: z.array(z.string()),
});
export const ContributionInformationDepotContextSchema = z.object({
    teleservice: TeleserviceSchema,
    contribution: ContributionInformationSchema,
    demandeFinancement: DemandeFinancementEntitySchema,
    pieces: ContributionInformationDepotContextPiecesSchema,
});
//# sourceMappingURL=contributions-information.js.map